import React from 'react'
import PropTypes from 'prop-types';
import styled from 'styled-components'
import { Icon, Row, Col } from 'antd';
import 'antd/dist/antd.css';
import constants from '../../config/constants'

const AppBar = styled.header`
  z-index: 1;
  width: 100%;
  position: fixed;
  background: #FFF;
  padding: 10px 0;
  top: 0;
  border-bottom: 2px solid ${constants.color.lightGrey2};
`

const StyledRow = styled(Row)`
  height: 30px !important;
  text-align: center;
`
const StyledCol = styled(Col)`
  height: 100%;
`

const StyledIcon = styled(Icon)`
  font-size: 16px;
  color: ${constants.color.iconDark} !important;
  margin-top: 0.2rem;
`

const Title = styled.h4`
  font-family: 'Thonburi';
`

const Header = (props) => {
  return (
    <div>
      <AppBar>
          <StyledRow>
            <StyledCol span={2} onClick={props.onClick}>
              { props.backIcon && <StyledIcon type="left" /> }
            </StyledCol>
            <StyledCol span={20}>
              { props.title && <Title>{props.title}</Title> }
            </StyledCol>
            <StyledCol span={2}>
              { props.closeIcon && <StyledIcon type="close" /> }
            </StyledCol>
          </StyledRow>
      </AppBar>
    </div>
  )
}

Header.propTypes = {
  title: PropTypes.string.isRequired,
  backIcon: PropTypes.bool,
  closeIcon: PropTypes.bool,
  onClick: PropTypes.func,
};

Header.defaultProps = {
  backIcon: false,
  closeIcon: false,
};

export default Header
